import { render } from "./sendCRMWhatsappMessageToCRMWhatsappContactDialog.vue?vue&type=template&id=54c43f54&scoped=true"
import script from "./sendCRMWhatsappMessageToCRMWhatsappContactDialog.vue?vue&type=script&lang=js"
export * from "./sendCRMWhatsappMessageToCRMWhatsappContactDialog.vue?vue&type=script&lang=js"

import "./sendCRMWhatsappMessageToCRMWhatsappContactDialog.vue?vue&type=style&index=0&id=54c43f54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c43f54"]])

export default __exports__